import { render, staticRenderFns } from "./FlexbenCompanySwitcher.vue?vue&type=template&id=f6e1a026"
import script from "./FlexbenCompanySwitcher.vue?vue&type=script&lang=js"
export * from "./FlexbenCompanySwitcher.vue?vue&type=script&lang=js"
import style0 from "./FlexbenCompanySwitcher.vue?vue&type=style&index=0&id=f6e1a026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports